import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { QUERY_ADMIN_DASHBOARD_TEAM_SETTINGS_KEY } from "../../../api/queryKeys";
import {
  QueryStandardSuccessResponse,
  MutationAdminInactivateTeamMemberRequestBody,
  APIStandardError,
} from "../../../types";
import { PERMISSION_DENIED } from "../../../api/codes";
import { ADMIN_TEAM_INACTIVATE } from "../../../api/queryKeys";

const inactivateTeamMember = (
  data: MutationAdminInactivateTeamMemberRequestBody
) => api.post(ADMIN_TEAM_INACTIVATE, data).then((res) => res.data);

export default function useInactivateTeamMember({
  onSuccessHandler,
}: {
  onSuccessHandler?: () => void;
}) {
  const queryClient = useQueryClient();
  return useMutation<
    QueryStandardSuccessResponse,
    AxiosError,
    MutationAdminInactivateTeamMemberRequestBody
  >(inactivateTeamMember, {
    onSuccess: (data) => {
      if (data.success) {
        queryClient.refetchQueries([QUERY_ADMIN_DASHBOARD_TEAM_SETTINGS_KEY]);
        toast.success("Account has been inactivated");

        if (onSuccessHandler) {
          onSuccessHandler();
        }
      }
    },
    onError: (error) => {
      const errorData = error.response?.data as APIStandardError;
      if (errorData?.code === PERMISSION_DENIED) {
        toast.error(errorData.detail);
        return;
      }
      toast.error("Error inactivating account");
    },
  });
}
